/* "Since your last visit" banner: parcels that moved to In process / Completed / Cancelled. */
import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { papi } from "./portalApi";

const PARTS = [["completed", "completed", "text-emerald-700"], ["in_process", "now in process", "text-sky-700"], ["cancelled", "cancelled", "text-rose-700"]];
const names = (l) => l.slice(0, 3).join(", ") + (l.length > 3 ? ` +${l.length - 3} more` : "");

export const PortalChanges = () => {
  const [c, setC] = useState(null);
  useEffect(() => { papi("get", "/changes").then((r) => { setC((o) => (r.added || PARTS.some(([k]) => r[k]?.length) ? r : o || r)); papi("post", "/changes/seen").catch(() => {}); }).catch(() => {}); }, []);
  if (!c) return null;
  const parts = PARTS.filter(([k]) => c[k]?.length);
  if (!parts.length && !c.added) return null;
  return (
    <div className="mb-3 flex items-start gap-3 rounded-xl border border-teal-200 bg-teal-50 px-4 py-3 text-sm" data-testid="portal-changes-banner">
      <BellRing className="mt-0.5 h-4 w-4 shrink-0 text-teal-700" />
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-slate-800">Since your last visit:{" "}
          {parts.map(([k, l, cls], i) => <span key={k} className={cls} data-testid={`portal-changes-${k}`}>{i ? " · " : ""}{c[k].length} parcel{c[k].length > 1 ? "s" : ""} {l}</span>)}
          {c.added > 0 && <span className="text-slate-600" data-testid="portal-changes-added">{parts.length ? " · " : ""}{c.added} new parcel{c.added > 1 ? "s" : ""} added</span>}</div>
        {parts.map(([k, l]) => <div key={k} className="truncate text-xs text-slate-500">{l[0].toUpperCase() + l.slice(1)}: {names(c[k])}</div>)}
      </div>
      <button onClick={() => setC(null)} className="rounded p-1 text-slate-500 hover:bg-teal-100" title="Dismiss" data-testid="portal-changes-close"><X className="h-4 w-4" /></button>
    </div>
  );
};
